<mat-form-field>
    <mat-label>{{title}}</mat-label>
    <mat-hint *ngIf="!!hint">{{hint}}</mat-hint>
    <mat-select multiple [formControl]="controller">
        <mat-option [value]="magicField.value" *ngIf="magicField"
            [disabled]="!controllerValue?.includes(magicField.value) && controllerValue?.length > 0">{{magicField.name}}</mat-option>

        <ng-container *ngFor="let item of lookup">
            <mat-option *ngIf="item.value" [disabled]=" magicField &&
                    (controllerValue?.includes(magicField?.value) && controllerValue?.length > 0)
                    " [value]="item.value">{{ item.name }}</mat-option>

            <mat-label  *ngIf="!item.value" class="mat-option-header">{{ item.name }}</mat-label>
        </ng-container>
    </mat-select>
</mat-form-field>